
import Tab from "./component";

export default Tab;
